// COPIED from Remote-Leverage/hriq@3b50a234afdd packages/design-system/lib/stacking-layers.ts by apps/web/scripts/sync-design-system.mjs. Do not edit: change it in Hriq and re-sync.
// @ts-nocheck -- type-checked in Hriq under its own compiler options (the CRM's are stricter).
/**
 * Central z-index contract for HRIQ UI layers.
 *
 * - Dialog overlay/content sit at 50/51 so the modal panel paints above the scrim.
 * - All portaled pickers/menus/popovers use 200+ so they reliably stack above dialogs.
 * - Nested portals (e.g. month picker over date picker) step up to 210+.
 * - Tooltips sit above popovers when needed.
 * - Drawer / shell / system layers use named tokens below (60+, 9990+, etc.).
 *
 * Import these class fragments everywhere instead of hard-coding z-[…] so stacking stays consistent.
 */
export const Z_LAYER = {
  dialogOverlay: "z-50",
  dialogContent: "z-[51]",
  /** Alert confirmations opened while a Dialog is open (must stack above dialog content). */
  alertDialogOverlay: "z-[52]",
  alertDialogContent: "z-[53]",
  /** Radix Select / Popover / Dropdown / Context menu content (portaled) */
  radixPopover: "z-[200]",
  /** Custom PortalDropdown full-screen dismiss layer */
  portalBackdrop: "z-[200]",
  portalPanel: "z-[201]",
  /** Date/time picker main popover */
  datePickerBackdrop: "z-[200]",
  datePickerPanel: "z-[201]",
  /** Month/year sub-picker above main picker */
  nestedPortalBackdrop: "z-[210]",
  nestedPortalPanel: "z-[211]",
  tooltip: "z-[205]",
  /** Slide-over panels (e.g. contact drawer) — above dialog chrome, below portaled pickers */
  drawerStack: "z-[60]",
  /** Mobile sidebar dismiss scrim */
  sidebarMobileBackdrop: "z-40",
  /** Dashboard edit-mode dim layer */
  dashboardDim: "z-30",
  /** In-app full-screen scrim below dialogs (e.g. payment gate) */
  appOverlayHigh: "z-[70]",
  /** Panel above `appOverlayHigh` (e.g. gate dropdown list) */
  appOverlayHighPanel: "z-[71]",
  /** Apps launcher full-screen picker */
  appsShellOverlay: "z-[9990]",
  /** Minimized app widgets taskbar */
  appsTaskbar: "z-[9980]",
  /** Blocking system overlays portaled above normal UI (idle, errors, welcome, forced password) */
  systemAlert: "z-[9999]",
  /** Pickers/menus opened from within a systemAlert overlay (must stack above z-[9999]) */
  systemAlertPortalBackdrop: "z-[10000]",
  systemAlertPortalPanel: "z-[10001]",
  /** Nested picker (e.g. month/year) inside a systemAlert overlay */
  systemAlertNestedPortalBackdrop: "z-[10002]",
  systemAlertNestedPortalPanel: "z-[10003]",
  /** Alert confirmations opened from within a systemAlert overlay */
  systemAlertAlertDialogOverlay: "z-[10004]",
  systemAlertAlertDialogContent: "z-[10005]",
} as const;

export type ZLayerToken = keyof typeof Z_LAYER;
